var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","content-class":"map-tooltip-wrapper"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"base-icon"},on),[_c('span',[_vm._v(_vm._s(_vm.base.code))])])]}}])},[_c('tooltip-content',{attrs:{"tooltip":_vm.tooltip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }